import { render, staticRenderFns } from "./Planejamento.vue?vue&type=template&id=515d0e3c&scoped=true"
import script from "./Planejamento.vue?vue&type=script&lang=js"
export * from "./Planejamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d0e3c",
  null
  
)

export default component.exports